import React from "react";
import AreaMenu, { Area, Menu } from "Components/AreaMenu";
import { Grid } from "@mui/material";
import { IconButton, RadioGroup } from "@gpstrackit/gtc-react-controls";
import { useIntl } from "react-intl";

export const Filters = ({filter, setFilter}) => {
  const { messages } = useIntl();

  const listFilters = [
    {
      label: messages["settingsDriver_driversFacesAll"],
      value: "all",
    },
    {
      label: messages["settingsDriver_driversFacesLinked"],
      value: "linked",
    },
    {
      label: messages["settingsDriver_driversFacesUnlinked"],
      value: "unlinked",
    },
  ];

  return (
    <Grid
      item
      style={{
        marginLeft: 6,
      }}
    >
      <AreaMenu>
        <Area>
          <IconButton
            tooltip={messages["filters"]}
            variant="secondary"
            icon="filter_list"
            placement="top"
          />
        </Area>
        <Menu>
          <div style={{ padding: "10px" }}>
            <RadioGroup
              list={listFilters}
              onChange={(e) => {
                setFilter(e);
              }}
              value={filter}
            />
          </div>
        </Menu>
      </AreaMenu>
    </Grid>
  );
};
